import { Box } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

export const CommonTypoGraphy = ({
  onClick,
  name,
}: {
  onClick: any;
  name: string;
}) => {
  return (
    <Box
      component='button'
      type='button'
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        cursor: 'pointer',
        color: '#0c4da2',
        bgcolor: '#eef4ff',
        border: '1px solid #d0e1fd',
        borderRadius: '6px',
        px: 1.25,
        py: 0.35,
        fontSize: { xs: '0.8rem', sm: '0.85rem' },
        fontWeight: 600,
        lineHeight: 1.3,
        textAlign: 'left',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          bgcolor: '#0c4da2',
          color: '#ffffff',
          borderColor: '#0c4da2',
          boxShadow: '0 2px 6px rgba(12, 77, 162, 0.25)',
        },
      }}
    >
      <VisibilityOutlinedIcon sx={{ fontSize: '0.95rem', flexShrink: 0 }} />
      <span style={{ wordBreak: 'break-word' }}>{name}</span>
    </Box>
  );
};

